(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/tickets-giftshop/assets/constants.js') >= 0) return;  svs.modules.push('/modules/tickets-giftshop/assets/constants.js');
"use strict";


const cache = {
  KEY: 'TICKETS_GIFTSHOP',
  DOMAIN: 'TUR'
};
const form = {
  GREETINGS_MAX: 160,
  GREETINGS_MAX_ERROR: 'Hälsningen är för lång',
  GREETINGS_LABEL: 'Hälsning',
  NAME_MAX: 50,
  NAME_MAX_ERROR: 'Namnet är för långt',
  NAME_LABEL: 'Till*',
  NAME_REQUIRED_ERROR: 'Du måste ange ett namn',
  INVALID_INPUT_ERROR: 'Tillåtna tecken: A-Ö a-ö 0-9 !?.,;:-_()<>^ och emojis',
  PHONE_LABEL: 'Ange mobilnummer',
  EMAIL_LABEL: 'Ange e-post'
};

const names = {
  NAME: 'name',
  PERSONAL_GREETING: 'personalGreeting',
  GREETING: 'greeting',
  PHONE: 'phone',
  EMAIL: 'email',
  RECEIVER_TYPE: 'receiverType',
  DATE: 'date',
  TIME: 'time',
  DATE_AND_TIME: 'dateAndTime',
  DATE_TIME_AND_NAME: 'dateTimeAndName',
  DATE_SELECTOR: 'dateSelector'
};
const legal = {
  PAYFOOTER_LEGAL_TEXT: '* Mottagaren måste ha fyllt 18 år och erhåller den lott och vinstplan som gäller vid tillfället för inlösen.'
};
const routes = {
  PREVIEW_ROUTE: '/forhandsgranska',
  GIFT_ROUTE: '/'
};
const cart = {
  MAX_TICKETS: 10,
  APPEND: 'append',
  SET: 'set',
  AMOUNT_LABEL: 'Antal'
};
const urlMappings = {
  TRISS_HOME: 'trissHome',
  SKRAPSPEL_HOME: 'skrapspelHome'
};
const branding = {
  TRISS: 'triss',
  SKRAPSPEL: 'skrapspel',
  DEFAULT: 'default'
};
const scrollIntoView = {
  SMOOTH: 'smooth',
  CENTER: 'center'
};
const dateSelectorKey = {
  NOW: 'NOW',
  DATE_AND_TIME: 'DATE',
  NAME_DAY_BY_DATE: 'NAME_DAY_BY_DATE',
  NAME_DAY_BY_LETTER: 'NAME_DAY_BY_LETTER',
  THEME_DAY_BY_DATE: 'THEME_DAY_BY_DATE'
};
const dateSelectorTabs = [{
  key: dateSelectorKey.NOW,
  label: 'Nu'
}, {
  key: dateSelectorKey.DATE_AND_TIME,
  label: 'Datum'
}, {
  key: dateSelectorKey.NAME_DAY_BY_DATE,
  label: 'Namnsdag'
}, {
  key: dateSelectorKey.NAME_DAY_BY_LETTER,
  label: 'Namnsdag A-Ö'
}, {
  key: dateSelectorKey.THEME_DAY_BY_DATE,
  label: 'Temadag'
}];
const themeDaysSubSet = ['Fettisdagen', 'Fössta Tossdan i Mass', 'Internationella kvinnodagen', 'Alla hjärtans dag', 'Sommartid', 'Kärlekens dag', 'Påskdagen', 'Valborgsmässoafton', 'Chokladbollens dag', 'Morsdag', 'Alla vänners dag', 'Sveriges nationaldag', 'Midsommarafton', 'Alla flickvänners dag', 'Kaffets dag', 'Trissens dag', 'Gräddtårtans dag', 'Alla pojkvänners dag', 'Kanelbullens dag', 'Vintertid', 'Grannens dag', 'Halloween', 'Alla helgons dag', 'Fars dag', 'Kladdkakans dag', 'Internationella mansdagen', 'Lucia', 'Julafton', 'Nyårsafton'];
svs.tickets_giftshop.constants = {
  cache,
  scrollIntoView,
  names,
  routes,
  cart,
  form,
  legal,
  urlMappings,
  branding,
  dateSelectorKey,
  dateSelectorTabs,
  themeDaysSubSet
};

 })(window);